module.exports = __webpack_public_path__ + "img/logo-syreta-full-white@3x.36ce2201.png";